/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { SelectionDetail } from '../UNSAFE_Collection';
import { Flex } from '../UNSAFE_Flex';
import { Checkbox } from '../UNSAFE_Selector';
import { usePress } from '../hooks/UNSAFE_usePress';
import { styles } from '../UNSAFE_Selector/themes/SelectorStyles.css';

/**
 * Props for the SelectorAll Component
 */
export type Props<K> = {
  /**
   * The selected state of the select all selector
   */
  selected: 'none' | 'all' | 'partial';
  /**
   * Callback function to invoke when the selected keys has changed when
   * the checkbox is toggled.
   */
  onChange?: (detail: SelectionDetail<K>) => void;
};

/**
 * The SelectorAll component renders checkboxes for select all case.
 */
export function SelectorAll<K>({ selected, onChange }: Props<K>) {
  const pressHandler = (event: Event) => {
    if (selected == 'none') {
      onChange && onChange({ value: { all: true, deletedKeys: new Set() }, target: event.target });
    } else {
      onChange && onChange({ value: { all: false, keys: new Set() }, target: event.target });
    }
  };

  const pressProps = usePress(pressHandler);

  // TODO: replace internal with Preact checkbox component once it is available
  return (
    <div class={styles.container} {...pressProps.pressProps}>
      <div class={styles.base}>
        <Flex align="center" justify="center" width="11x" height="11x">
          <Checkbox checked={selected !== 'none'} isPartial={selected === 'partial'} />
        </Flex>
      </div>
    </div>
  );
}
